import { enUS } from 'locales/locales.types';
import { useTranslation as _useTranslation } from 'react-i18next';

export const useTranslation = () => _useTranslation<enUS>();
